export default __webpack_public_path__ + "static/media/estar.acfaa142.svg";